import { render, staticRenderFns } from "./company-work-group.vue?vue&type=template&id=172085ec&scoped=true"
import script from "./company-work-group.vue?vue&type=script&lang=js"
export * from "./company-work-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172085ec",
  null
  
)

export default component.exports